import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import form_styles from "../../Form/Form.module.css";
import FieldCustom from "../../Field/FieldCustom";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import FieldUpload from "../../Field/FieldUpload";
import modalSuccess from "../../Modal/ModalSuccess";
import {useModal} from "../../../contexts/ModalContext";
import {navigate} from "react-big-calendar/lib/utils/constants";
import {Link, useNavigate} from "react-router-dom";
import BtnSave from "../../Button/BtnSave";
import TitleSecondary from "../../Title/TitleSecondary";
import TitleMain from "../../Title/TitleMain";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faBackspace, faBackward} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";

function EntrepriseCreation({entreprise = null}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [inputs, setInputs] = useState([]);
    const [initialValues, setInitialValues] = useState({});
    let navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    useEffect(() => {
        const newInputs = [{
            type: 'text',
            name: 'nom',
            label: 'Nom',
            placeholder: 'Nom de l\'entreprise',
            value: entreprise?.nom || ''
        }, {
            type: 'text',
            name: 'addr',
            label: 'Adresse',
            placeholder: 'Adresse de l\'entreprise',
            value: entreprise?.addr || ''
        }, {
            type: 'text',
            name: 'cp',
            label: 'Code Postal',
            placeholder: 'Code Postal',
            value: entreprise?.cp || ''
        }, {
            type: 'text',
            name: 'ville',
            label: 'Ville',
            placeholder: 'Ville',
            value: entreprise?.ville || ''
        }, {
            type: 'text',
            name: 'pays',
            label: 'Pays',
            placeholder: 'Pays',
            value: entreprise?.pays || ''
        }, {
            type: 'textarea',
            name: 'description',
            label: 'Description',
            placeholder: 'Description de l\'entreprise',
            value: entreprise?.description || ''
        }, {
            type: 'text',
            name: 'siret',
            label: 'SIRET',
            placeholder: 'SIRET',
            value: entreprise?.siret || ''
        },
        ];
        setInputs(newInputs);

        const newInitialValues = newInputs.reduce((acc, input) => ({
            ...acc, [input.name]: input.value
        }), {});

        setInitialValues(newInitialValues);
    }, [entreprise]);


    const handleSubmit = async (values, {setSubmitting}) => {
        values.entreprise_id = entreprise?.id || null;
        try {
            const response = await AxiosConfig.post('/admin/entreprises/creation', values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                navigate(`/admin/entreprises/${response.data.id}`);
            } else {
                handleError(response.data.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="content">
            <TitleMain text={entreprise ? entreprise.nom : "Entreprises"}/>
            <div style={{margin: '0 0 50px 0'}} className={styles.viewBloc}>
                <TitleSecondary text={entreprise ? "Modifier l'entreprise" : "Créer une entreprise"}/>

                {Object.keys(initialValues).length > 0 ? (<>
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                        {({isSubmitting}) => (<Form>
                            {inputs.map((input, index) => (<FieldCustom {...input} key={index}/>))}

                            <div className={"barre_btn"}>
                                <button type={"button"} onClick={() => {navigate(-1)}} className={"btn btn_danger"}>
                                    <AnnulerIcone />
                                    Annuler
                                </button>
                                <BtnSave isSubmitting={isSubmitting}/>
                            </div>

                        </Form>)}
                    </Formik>
                </>) : (<p>Chargement...</p>)}

            </div>
        </div>);
}

export default EntrepriseCreation;